import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTypes } from "../../../../constants";

import { Container, Grid } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import EventCard from "./EventCard";
import Fetching from "../../../Common/Fetching";

import tmsActions from "../../../../actions/tmsActions";
import { getEvents, isFetching } from "../../../../reducers";

function EventList() {
    const events = useSelector(getEvents);
    const dispatch = useDispatch();

    const isLoading = useSelector((state) =>
        isFetching(state, DataTypes.TMS_EVENTS)
    );

    useEffect(() => {
        dispatch(
            tmsActions.getEvents("C-TMS", { start: new Date(), limit: 50 })
        );
    }, [dispatch]);

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                {isLoading && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {events?.map((event) => (
                    <Grid
                        item
                        md={12}
                        lg={6}
                        xl={4}
                        key={event.id}
                        className="card-grid-item"
                    >
                        <EventCard key={event.id} data={event} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default EventList;
